<template>
<div class="chapter">
<div class="inner_page">
<div>
<br/>
<br/>
<br/>
<p class="ded"><i>For John Coltrane<br/>
    the heaviest spirit</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c6.vue?1db9b728